import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { SdkConfigService } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/config/sdk-config.service';
import { environment } from './environments/environment';

SdkConfigService.configure({
  baseUrl: environment.API_BASE,
  isAdmin: false,
  apiKey: '',
  mockConfig: {
    dms: true,
    tasks: false,
    plants: false,
    cultivations: false,
    'cultivation-periods': false,
    'botanic-families': true,
    'growing-steps': false,
    'plants-to-growing-steps': false,
    'user-suggestions': false,
    risks: true,
    social: true,
    user: false,
    users: false,
    weather: false,
    locations: false,
    notifications: true,
  },
  storeOnMobile: true,
  accessTokenName: 'access_token',
  refreshTokenName: 'refresh_token',
  addressName: 'address-uid',
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
